import { ComponentPropsWithRef, ReactNode } from "react";
import styled from "styled-components";
import { primary03, shade0, shade700 } from "../../styles/tokens";

// TEXT

// STYLES
export const IconButton = styled.button<Props>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--icon-button-base-color, ${shade0});
  transition: color 0.3s ease;

  &:not([disabled]) {
    cursor: pointer;
  }

  &:hover:not([disabled]) {
    color: ${primary03};
  }

  height: ${({ $height, $small }) => {
    if ($height) return $height;
    if ($small) return "1.5rem";

    return "3rem";
  }};
  width: ${({ $width, $small }) => {
    if ($width) return $width;
    if ($small) return "1.5rem";

    return "3rem";
  }};

  &:focus-visible:not([disabled]) {
    color: ${primary03};
    /* Inset ring avoids clipping inside overflow:auto/hidden ancestors (e.g. panel scroll). */
    ${({ $height, $width, $small }) =>
      $height || $width || $small
        ? `box-shadow: inset 0 0 0 1px ${shade0};`
        : `outline: 1px solid ${shade0}; outline-offset: 2px;`}
  }

  color: ${({ $active }) => $active && primary03};

  &[disabled],
  &:disabled {
    color: ${shade700};
    cursor: not-allowed;
  }
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"button"> {
  $active?: boolean;
  $height?: string;
  $width?: string;
  $small?: boolean;
  children?: ReactNode;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
